import { Controller } from "@hotwired/stimulus"

// Submits the surrounding form when a filter changes: `change->form-autosubmit#submit`
// on selects, `input->form-autosubmit#debounced` on text fields.
export default class extends Controller {
  static values = { delay: { type: Number, default: 400 } }

  submit() {
    this.element.requestSubmit()
  }

  debounced() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.submit(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
